import Controller from 'controllers/controller';
import Elements from 'tools/elements';
import FadingGalleryController from 'controllers/components/fading-gallery';

/**
 * @class FadingGalleriesController - This class finds all fading-galleries on the page, and instantiates individual
 * FadingGalleryController classes for each.
 */
class FadingGalleriesController extends Controller {
    ready() {
        this.elements = new Elements();
        
        this.controllerInstances = [ ];

        this.attachEvents();
        this.findNewGalleries();
    }

    attachEvents() {
        this.app.on('dom-change', this.findNewGalleries);
    }

    findNewGalleries() {
        this.cacheElements();
        this.initControllers();
    }
    
    cacheElements() {
        this.elements.queryAll('galleries', '.fading-gallery');
    }

    removeInstance(instance) {
        let index = this.controllerInstances.indexOf(instance);
        
        if (index !== -1) {
            // Remove instance from array
            this.controllerInstances.splice(index, 1);
        }
    }

    /**
     * Get the corresponding gallery instance for an element.
     * 
     * @param {HTMLElement} gallery
     * @return {*|null}
     */
    getInstance(gallery) {
        return gallery && gallery.__fadingGalleryInstance || null;
    }
    
    initControllers() {
        this.elements.each('galleries', gallery => {
            // Don't double instantiate
            if (this.getInstance(gallery)) {
                return;
            }
            
            this.controllerInstances.push(
                this.app.make(FadingGalleryController, gallery)
            );
        })
    }
}

export default FadingGalleriesController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/fading-galleries.js